import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// import "amfe-flexible/index.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import "./permission";
// 完整导入 UI 组件库
import VxeUI from "vxe-pc-ui";
import "vxe-pc-ui/lib/style.css";

// 完整导入 表格库
import VxeUITable from "vxe-table";
import "vxe-table/lib/style.css";

// 将自动注册所有组件为全局组件
import dataV from "@jiaminghi/data-view";
import "@vuemap/vue-amap/dist/style.css";
import ModeHeadTitle from "@/components/modeheadtitle/modeheadtitle.vue";
import customed from "@/theme/echarts/customed";
import aheader from "@/components/head/aheader.vue";
import MenuComs from "@/components/menucoms/menucoms";
import * as echarts from "echarts";
import scroll from "vue-seamless-scroll";
import gdmap from "@/components/gdmap/gdmap";
import CommunityMap from "@/components/CommunityMap/CommunityMap";
import aruitab from "@/components/Arui/aruitab.vue";

import highcharts from "highcharts";
import highcharts3d from "highcharts/highcharts-3d";
import mintitle from "@/components/Arui/mintitle.vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "videojs-contrib-hls";
import Vue2OrgTree from "vue2-org-tree";
import "vue2-org-tree/dist/style.css";
import VueAMap from "@vuemap/vue-amap";
import "@vuemap/vue-amap/dist/style.css";

Vue.prototype.echarts = echarts;
Vue.prototype.customed = customed;
highcharts3d(highcharts);

Vue.use(Vue2OrgTree);
Vue.component("MenuComs", MenuComs); //全局挂载组件
Vue.component("ModeHeadTitle", ModeHeadTitle); //全局挂载组件
Vue.component("aheader", aheader); //全局挂载组件
Vue.component("gdmap", gdmap); //全局挂载组件
Vue.component("CommunityMap", CommunityMap);
Vue.component("aruitab", aruitab); //全局挂载组件
Vue.component("mintitle", mintitle); //全局挂载组件

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "e07093b09559e9529e4c30f643a537f9",
  // v: "1.4.9",
});

Vue.use(VxeUI);
Vue.use(VxeUITable);
Vue.use(videoPlayer);
Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(scroll);

Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
